export enum BONUS_CATALOG_FORM_ITEMS {
  NAME = 'name',
  COLOR = 'color',
  TITLE = 'title',
  DESCRIPTION = 'description',
  PICTURE = 'picture',
  PAYOUT_OPTION = 'payoutOption',
  PAYOUT_TYPE = 'payoutType',
  SHOW_PAYMENT_OPTION = 'showUiPaymentOptions',
}
